var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.classes,style:(_vm.ctaStyles),on:{"click":function($event){_vm.handleClick($event)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.ctaText)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d52556","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/grad-images/catalog-list/components/PackageCtaLink.vue
// module id = 531
// module chunks = 0 2 5 6 14